import { useRef } from 'react'
import { com } from '@eidu/web'
import usePermittedActions from '../../io/usePermittedActions'
import GlobalAction = com.eidu.sharedlib.entity.permission.GlobalAction
import PermittedGlobalAction = com.eidu.sharedlib.entity.permission.PermittedGlobalAction

const useHasGlobalPermissions = (...actions: GlobalAction[]) => {
  const requested = useRef(actions.map((action) => new PermittedGlobalAction(action)))
  const { permissions, error, isLoading } = usePermittedActions(requested.current)

  const hasPermission = (action: GlobalAction) =>
    permissions?.some((p) => p.equals(new PermittedGlobalAction(action))) ?? false

  return { hasPermission, error, loading: isLoading }
}

export default useHasGlobalPermissions
